import { MessageCircle } from "lucide-react";
import { API } from "@/lib/api";
import { useBranding } from "@/context/AuthContext";

export const BrandLogo = ({ size = 36, className = "" }) => {
  const { data } = useBranding();
  if (data?.has_logo) {
    return (
      <img
        data-testid="brand-logo-image"
        src={`${API}/branding/logo?v=${data.logo_version}`}
        alt={data.company_name}
        style={{ width: size, height: size }}
        className={`rounded-lg object-cover bg-white ${className}`}
      />
    );
  }
  return (
    <div style={{ width: size, height: size }} className={`rounded-lg bg-[#25D366] grid place-items-center ${className}`}>
      <MessageCircle className="text-white" size={size * 0.55} strokeWidth={2.4} />
    </div>
  );
};
